import { MenuBuilder } from './MenuBuilder'
import { MobileButtonBuilder } from './MobileButtonBuilder'
import { ResizeObserver } from './ResizeObserver'
// const siteWrapper =
(async () => {
	const resizeObserver = new ResizeObserver(1200)

	const menuBuilder = new MenuBuilder(resizeObserver)

	window.menu = await menuBuilder.build('[data-navbar-content]')

	window.menu.on('open', () => {
		document.getElementById('shark-cookie').classList.add('removed')
		document.querySelector('.site-wrapper').classList.add('open')
		document.querySelector('.mobile-logo').classList.add('down')
		document.getElementById('navbar-socials').classList.add('expand')
		document.querySelector('.mobile-bar').classList.add('hidden')
		document.body.style.backgroundColor = '#fff'
		document.getElementById('navbar-socials').style.display="block"
	})
	window.menu.on('close', () => {
		document.getElementById('shark-cookie').classList.remove('removed')
		document.querySelector('.site-wrapper').classList.remove('open')
		document.querySelector('.mobile-logo').classList.remove('down')
		document.getElementById('navbar-socials').classList.remove('expand')
		document.querySelector('.mobile-bar').classList.remove('hidden')
		document.body.style.backgroundColor = '#f7f7f7'

		document.getElementById('navbar-socials').style.display="none"
	})

	const menuButtonBuilder = new MobileButtonBuilder(window.menu)
	window.menuButton = menuButtonBuilder.build('[data-navbar-button]')

	const submenuOpenHandler = submenu => {
		if (!window.menu.isMobile) return false
		const submenuNode = submenu.node.querySelector('.submenu')
		const subitemsNodes = [...submenuNode.querySelectorAll('.subitem')]
		let subitemstTotalHeight = 0
		subitemsNodes.forEach((e) => {
			subitemstTotalHeight += e.offsetHeight
		})
		submenuNode.style.height = `${subitemstTotalHeight}px`
	}

	const submenuCloseHandler = submenu => {
		if (!window.menu.isMobile) return false
		const submenuNode = submenu.node.querySelector('.submenu')
		submenuNode.style.height = '0px'
	}

	window.menu.submenus.map(submenu => {
		submenu.on('before:open', submenuOpenHandler)
		submenu.on('before:close', submenuCloseHandler)
	})
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/script.js